<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">Stock Transfer</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="handlerefresh"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        :to="{ name: 'stock-transfer-add'} "
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        @click="handleview"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="handlefilter"
                    >Filter</vs-button>
                    <vs-button
                        @click="handleexport"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="import_export"
                    >Export</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="stocktransfer.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="stocktransfer.columnDefs"
                :defaultColDef="stocktransfer.defaultColDef"
                :rowData="stocktransfer.rowdata"
                colResizeDefault="shift"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="handleview"
                :animateRows="false"
                :floatingFilter="false"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ stocktransfer.dataFrom }} to {{ stocktransfer.dataTo }} of {{ stocktransfer.dataTotal }} total entries</b>
            </p>
            <vs-pagination
                :total="stocktransfer.totalPage"
                v-model="stocktransfer.currentPage"
                :max="7"
            ></vs-pagination>
        </vx-card>
        <vs-prompt buttons-hidden title="Filter" :active.sync="stocktransfer.filtershow">
            <div class="con-exemple-prompt">
                <div class="vx-col w-full mb-2">
                    <vs-input class="w-full" v-model="stocktransfer.filter.transfer_id" label="Transfer ID"/>
                </div>
                <div class="vx-col w-full mb-2">
                    <vs-input class="w-full" v-model="stocktransfer.filter.reference" label="Reference"/>
                </div>
                <label class="vs-input--label">Posting Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr
                            class="vx-col  w-full p-2"
                            v-model="stocktransfer.filter.posting_date"
                        />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">
                        To
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr
                            class="vx-col w-full p-2"
                            v-model="stocktransfer.filter.posting_date_to"
                        />
                    </vs-col>
                </vs-row>
                <label class="vs-input--label">Transaction Type</label>
                <vx-input-group class="mb-3">
                    <vs-input v-model="stocktransfer.filter.transaction_type"/>
                    <template slot="append">
                        <div class="append-text btn-addon">
                            <vs-button
                                size="small"
                                color="primary"
                                icon-pack="feather"
                                icon="icon-search"
                                type="border"
                                @click="handlepopuptransactiontype"
                            ></vs-button>
                        </div>
                    </template>
                </vx-input-group>
                <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
                    <vs-button color="primary" @click="handlestocktransferfilter">Search</vs-button>
                </vs-row>
            </div>
        </vs-prompt>
        <!-- <vs-popup title="Filter" :active.sync="stocktransfer.filtershow" style="z-index: 99998">
            <vs-row>
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col w-full">
                        <vs-input class="w-full" v-model="stocktransfer.filter.transfer_id" label="Transfer ID"/>
                    </div>
                </div>
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col w-full">
                        <vs-input class="w-full" v-model="stocktransfer.filter.reference" label="Reference"/>
                    </div>
                </div>
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Posting Date</span>
                    </div>
                    <div class="vx-row sm:w-2/3 w-full" style="margin-left: 12px">
                        <flat-pickr
                            class="vx-col sm:w-1/3 w-full p-2"
                            v-model="stocktransfer.filter.posting_date"
                        />
                        <div class="vx-col">
                            <span>To</span>
                        </div>
                        <flat-pickr
                            class="vx-col sm:w-1/3 w-full p-2"
                            v-model="stocktransfer.filter.posting_date_to"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Transaction Type</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vx-input-group>
                            <vs-input
                                class="w-full"
                                v-model="stocktransfer.filter.transaction_type"
                            />

                            <template slot="append">
                                <div class="append-text btn-addon">
                                    <vs-button
                                        size="small"
                                        color="primary"
                                        type="border"
                                        icon-pack="feather"
                                        icon="icon-search"
                                        @click="handlepopuptransactiontype"
                                    ></vs-button>
                                </div>
                            </template>
                        </vx-input-group>
                    </div>
                </div>
            </vs-row>
            <vs-row class="flex justify-end">
                <vs-button
                    @click="handlestocktransferfilter"
                    class="mr-4"
                    color="primary"
                    type="filled"
                >Filter</vs-button>
                <vs-button
                    @click="stocktransfer.filtershow = !stocktransfer.filtershow"
                    type="flat"
                >Cancel</vs-button>
            </vs-row>
        </vs-popup> -->
        <!-- Pop Up Transaction Type -->

        <vs-popup
            title="Transaction Type"
            :active.sync="transactiontype.show"
            style="z-index: 99999"
        >
            <vx-input-group>
                <vs-input
                    class="w-full"
                    v-model="transactiontype.search"
                    placeholder="Search Transaction Type"
                />

                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handletransactiontypesearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="transactiontype.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="transactiontype.columnDefs"
                :defaultColDef="transactiontype.defaultColDef"
                :rowData="transactiontype.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclicktransactiontype"
                @selection-changed="onchangeselectiontransactiontype"
            ></ag-grid-vue>
        </vs-popup>
    </div>
</template>
<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            stocktransfer: {
                show: false,
                filtershow: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                filter: {},
                select: {},
                totalPage: 0,
                currentPage: 1,
                dataFrom: 0,
                dataTo: 0,
                dataTotal: 0
            },
            transactiontype: {
                show: false,
                filtershow: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                filter: {},
                search: "",
                select: {},
                totalPage: 0,
                currentPage: 1,
                dataFrom: 0,
                dataTo: 0,
                dataTotal: 0
            },
            selectedId: null
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.stocktransfer.gridoptions.api.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        toggleLoading() {
            this.isLoading = !this.isLoading;
        },
        // Handle Button
        handlerefresh() {
            this.getStockTransfer();
        },
        handleview() {
            this.$router.push({
                name: "stock-transfer-view",
                params: {
                    id: this.selectedId
                }
            });
        },
        handlefilter() {
            this.stocktransfer.filtershow = !this.stocktransfer.filtershow;
        },
        handleexport() {
            console.log("handleexport");
        },
        // Filter
        handlestocktransferfilter() {
            console.log("Do Filter");
            this.handlefilter();
            this.getStockTransfer();
        },
        // Handle Pop UP
        handlepopuptransactiontype() {
            this.getTransactionType();
            this.transactiontype.gridoptions.api.sizeColumnsToFit();
        },
        // handle Search
        handletransactiontypesearch() {
            this.getTransactionType();
        },
        // Handle On Doubke Click
        rowdoubleclicktransactiontype() {
            this.handlepopuptransactiontype();
        },
        // Handle On
        onchangeselectiontransactiontype() {
            let selectedRows = this.transactiontype.gridoptions.api.getSelectedRows();
            this.transactiontype.select = selectedRows[0];
            this.stocktransfer.filter.transaction_type = selectedRows[0].type;
        },
        // Get Api on Selection Change
        getStockTransfer() {
            this.stocktransfer.rowdata = [];
            this.toggleLoading();
            Promise.all([
                this.$http.post("inventories/stocktransfer", {
                    id: this.stocktransfer.filter.transfer_id,
                    refrence: this.stocktransfer.filter.reference,
                    posting_date: this.stocktransfer.filter.posting_date,
                    transaction_type_id: this.stocktransfer.filter
                        .transaction_type,
                    remark: this.stocktransfer.filter.remark
                })
            ])
                .then(
                    this.$http.spread(stocktransfer => {
                        this.stocktransfer.rowdata = stocktransfer.data.data;
                        this.stocktransfer.totalPage =
                            stocktransfer.data.last_page;
                        this.stocktransfer.dataFrom =
                            stocktransfer.data.from || 0;
                        this.stocktransfer.dataTo = stocktransfer.data.to || 0;
                        this.stocktransfer.dataTotal = stocktransfer.data.total;
                        this.toggleLoading()
                    })
                )
                .catch(err => console.log(err))
                // .then(this.toggleLoading());
        },
        getTransactionType() {
            if(this.transactiontype.rowdata.length < 1) {
                this.toggleLoading();
                Promise.all([this.$http.post("master/transactiontypes")])
                    .then(
                        this.$http.spread(transactiontype => {
                            this.transactiontype.rowdata =
                                transactiontype.data.data;
                            this.transactiontype.show = !this.transactiontype.show;
                        })
                    )
                    .catch(err => console.log(err))
                    .then(this.toggleLoading());
            }
            else {
                this.transactiontype.show = !this.transactiontype.show;
            }
        }
    },
    computed: {},
    mounted() {
        this.getStockTransfer();
    },
    beforeMount() {
        this.stocktransfer.columnDefs = [
            {
                headerName: "Transfer ID",
                field: "id",
                width: 120
            },
            {
                headerName: "Reference",
                field: "reference",
                width: 120
            },
            {
                headerName: "Posting Date",
                field: "posting_date",
                width: 120
            },
            {
                headerName: "Type",
                field: "type",
                width: 120
            },
            {
                headerName: "Remark",
                field: "remark",
                width: 120
            }
        ];
        this.transactiontype.columnDefs = [
            {
                headerName: "Type",
                field: "type",
                width: 120
            },
            {
                headerName: "Description",
                field: "description",
                width: 120
            }
        ];

        this.stocktransfer.gridoptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>